import React from 'react';
import PropTypes from 'prop-types';

function CourseIcon({ id }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0"
      y="0"
      enableBackground="new 0 0 91 91"
      version="1.1"
      viewBox="0 0 91 91"
      xmlSpace="preserve"
      role="img"
      aria-labelledby="course-icon-title"
    >
      <title id="course-icon-title">Course Icon</title>
      <g>
        <g transform="translate(6 4)">
          <g>
            <linearGradient
              id={`path-2_2_${id}`}
              x1="-427.856"
              x2="-427.856"
              y1="319.596"
              y2="317.776"
              gradientTransform="matrix(50 0 0 -50 21432.273 15975.786)"
              gradientUnits="userSpaceOnUse"
            >
              <stop className="startColor" offset="0" />
              <stop className="endColor" offset="1" />
            </linearGradient>
            <circle
              cx="39.5"
              cy="41.5"
              r="45.5"
              fill={`url(#path-2_2_${id})`}
            />
          </g>
          <g transform="translate(7 12)">
            <g>
              <path
                fill="#1F436D"
                d="M32.6 36.7L9.5 25.9 9.5 40.6 32.6 52.2 55.7 40.6 55.7 25.9z"
              />
              <g fill="#E7ECED" transform="translate(32.882 7.455)">
                <path d="M32.5 33.1c-1.1 0-1.9-.9-1.9-1.9V13.9c0-1.1.9-1.9 1.9-1.9 1.1 0 1.9.9 1.9 1.9v17.3c0 1.1-.9 1.9-1.9 1.9z" />
                <path d="M28.6 38.9c-.4 0-.7-.1-1.1-.3-.9-.6-1.1-1.8-.5-2.7l3.9-5.8c.6-.9 1.8-1.1 2.7-.5.9.6 1.1 1.8.5 2.7l-3.9 5.8c-.3.5-1 .8-1.6.8z" />
                <path d="M36.3 38.9c-.6 0-1.2-.3-1.6-.9l-3.9-5.8c-.6-.9-.4-2.1.5-2.7.9-.6 2.1-.4 2.7.5l3.9 5.8c.6.9.4 2.1-.5 2.7-.3.3-.7.4-1.1.4z" />
              </g>
              <path
                fill="#15324F"
                d="M32.6 44.5c-1.1 0-1.9-.9-1.9-1.9V33c0-1.1.9-1.9 1.9-1.9 1.1 0 1.9.9 1.9 1.9v9.6c0 1-.8 1.9-1.9 1.9z"
              />
              <path
                fill="#366DB6"
                d="M32.6 5.9L-0.1 21.3 32.6 36.7 65.4 21.3z"
              />
              <path
                fill="#E7ECED"
                d="M65.4 23.3H32.6c-1.1 0-1.9-.9-1.9-1.9 0-1.1.9-1.9 1.9-1.9h32.8c1.1 0 1.9.9 1.9 1.9 0 1-.9 1.9-1.9 1.9z"
              />
              <path
                fill="#E7ECED"
                d="M32.6 27.1c-1.1 0-1.9-.9-1.9-1.9v-7.7c0-1.1.9-1.9 1.9-1.9 1.1 0 1.9.9 1.9 1.9v7.7c0 1.1-.8 1.9-1.9 1.9z"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

CourseIcon.propTypes = {
  id: PropTypes.string,
};

CourseIcon.defaultProps = {
  id: '',
};

export default React.memo(CourseIcon);
